import { graphql, useStaticQuery } from 'gatsby';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import Seo from '../seo';

const BlogSeo = ({ meta = {}, slug }) => {
  const { site, siteSettings } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        siteSettings: contentfulBlogSettings(contentful_id: { eq: "6KdgnoVe8iL9MGRTTPgqyQ" }) {
          ...SiteSettings
        }
      }
    `
  );
  const pageTitle = get(meta, 'pageTitle') || get(siteSettings, 'pageTitle') || site.siteMetadata.title;
  const metaDescription =
    get(meta, 'metaDescription.metaDescription') ||
    get(siteSettings, 'metaDescription.metaDescription') ||
    site.siteMetadata.description;
  const metaOgImageUrl = get(meta, 'ogImageUrl') || get(siteSettings, 'ogImage.resize.src', '');
  const metaOgImageTitle = get(meta, 'ogImageAlt');
  const isNoFollow = get(meta, 'noFollow[0]');

  return (
    <Seo
      title={pageTitle}
      noFollow={isNoFollow === 'Yes'}
      description={metaDescription}
      ogImageUrl={metaOgImageUrl}
      ogImageAlt={metaOgImageTitle}
      slug={slug}
    />
  );
};

BlogSeo.propTypes = {
  meta: PropTypes.shape({
    metaDescription: PropTypes.object,
    pageTitle: PropTypes.string,
    ogImage: PropTypes.object,
  }),
};

export default BlogSeo;
